// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Cross-Browser Compatibility Styles for StockManager */
/* Edge, Chrome, Firefox 브라우저 호환성을 위한 글로벌 스타일 */

/* Edge/IE에서 폰트 렌더링 최적화 */
html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  font-feature-settings: "kern" 1;
}

body {
  font-family: "Pretendard", "Noto Sans KR", "Apple SD Gothic Neo", "Malgun Gothic", "맑은 고딕", "Roboto", "Segoe UI", "Helvetica Neue", "Arial", sans-serif;
  font-optical-sizing: auto;
  font-variation-settings: "wght" 400;
  /* Edge에서 기본 여백 제거 */
  margin: 0;
  padding: 0;
}

/* 브라우저별 박스 모델 통일 */
*, *::before, *::after {
  box-sizing: border-box;
}

/* Edge에서 input 요소 스타일 통일 */
input, textarea, select, button {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

/* Edge에서 placeholder 스타일 통일 */
input::placeholder,
textarea::placeholder {
  color: rgba(0, 0, 0, 0.6);
  opacity: 1;
}

/* Edge/IE placeholder 호환성 */
input::-ms-input-placeholder,
textarea::-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.6);
}

/* 다크모드 placeholder 스타일 */
[data-theme="dark"] input::placeholder,
[data-theme="dark"] textarea::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

[data-theme="dark"] input::-ms-input-placeholder,
[data-theme="dark"] textarea::-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.7);
}

/* Edge에서 버튼 스타일 통일 */
button {
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  font-family: inherit;
}

button:focus {
  outline: 2px solid var(--theme-palette-primary-main, #4a5568);
  outline-offset: 2px;
}

button:focus:not(:focus-visible) {
  outline: none;
}

/* Edge에서 스크롤바 스타일 통일 */
/* Webkit browsers (Chrome, Edge) */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* 다크모드 스크롤바 */
[data-theme="dark"] ::-webkit-scrollbar-track {
  background: #2d3748;
}

[data-theme="dark"] ::-webkit-scrollbar-thumb {
  background: #4a5568;
}

[data-theme="dark"] ::-webkit-scrollbar-thumb:hover {
  background: #718096;
}

/* Firefox scrollbar */
* {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

[data-theme="dark"] * {
  scrollbar-color: #4a5568 #2d3748;
}

/* Edge에서 Material-UI 컴포넌트 여백 일관성 */
.MuiPaper-root > *:first-child {
  margin-top: 0;
}

.MuiPaper-root > *:last-child {
  margin-bottom: 0;
}

.MuiCard-root > .MuiCardContent-root > *:first-child {
  margin-top: 0;
}

.MuiCard-root > .MuiCardContent-root > *:last-child {
  margin-bottom: 0;
}

/* 브라우저별 Paper/Card 컴포넌트 패딩 보정 */
/* Firefox와 다른 브라우저에서 MUI sx prop 패딩 값이 제대로 적용되지 않는 문제 해결 */
@supports (-moz-appearance:none) {
  /* 포트폴리오 페이지 통계 카드 패딩 강제 적용 */
  .portfolio-stats-card {
    padding: 24px !important;
  }
  
  /* Grid 컨테이너 내부 Paper 컴포넌트 기본 패딩 */
  .MuiGrid-item .MuiPaper-root:not(.MuiTableContainer-root) {
    /* MUI의 sx={{ p: 3 }}는 24px 패딩 */
    padding: 24px !important;
  }
  
  /* 테이블 컨테이너는 패딩 제외 */
  .MuiTableContainer-root.MuiPaper-root {
    padding: 0 !important;
  }
  
  /* 보유 종목 테이블 헤더 박스는 별도 패딩 */
  .MuiPaper-root > .MuiBox-root:first-child {
    padding: 16px;
  }
  
  /* Card 컴포넌트는 CardContent가 패딩 처리 */
  .MuiCard-root {
    padding: 0 !important;
  }
  
  .MuiCardContent-root {
    padding: 24px !important;
  }
  
  .MuiCardContent-root:last-child {
    padding-bottom: 24px !important;
  }
  
  /* Dialog, Drawer, Menu는 기본값 유지 */
  .MuiDialog-paper,
  .MuiDrawer-paper,
  .MuiMenu-paper,
  .MuiPopover-paper,
  .MuiAlert-root {
    padding: 0 !important;
  }
  
  /* Typography 요소 간격 보정 */
  .MuiPaper-root .MuiTypography-h6 {
    margin-bottom: 16px;
  }
  
  /* Box 컴포넌트 내부 요소 간격 */
  .MuiPaper-root .MuiBox-root {
    box-sizing: border-box;
  }
}

/* 테이블 컨테이너 패딩 제거 */
.MuiTableContainer-root.MuiPaper-root {
  padding: 0 !important;
}

/* =====================================
   계좌 관리 페이지 최적화 (Phase 5)
   ===================================== */

/* 계좌 카드 스타일은 Accounts.js sx prop으로 이동됨 */

/* =====================================
   포트폴리오 페이지 종목 카드 최적화
   ===================================== */

/* 종목 카드 스타일은 Portfolio.js sx prop으로 이동됨 */

/* =====================================
   모바일 Bottom Navigation 최적화
   ===================================== */

/* Bottom Navigation 스타일은 MobileBottomNavigation.js sx prop으로 이동됨 */
/* 하단 메뉴를 고려한 본문 여백만 유지 */
@media (max-width: 600px) {
  .main-content {
    padding-bottom: 64px;
  }
}

/* Edge에서 그리드 레이아웃 일관성 */
.MuiGrid-container {
  width: 100%;
}

/* Edge에서 Typography 여백 일관성 */
.MuiTypography-gutterBottom {
  margin-bottom: 0.35em;
}

.MuiTypography-paragraph {
  margin-bottom: 16px;
}

/* Edge에서 폰트 가중치 일관성 */
.MuiTypography-h1,
.MuiTypography-h2,
.MuiTypography-h3,
.MuiTypography-h4,
.MuiTypography-h5,
.MuiTypography-h6 {
  font-weight: 600;
  line-height: 1.2;
}

/* Edge에서 한글 폰트 최적화 */
.MuiTypography-root[lang="ko"],
.MuiTypography-root:lang(ko) {
  word-break: keep-all;
  overflow-wrap: break-word;
}

/* Edge에서 Card 호버 효과 일관성 */
.MuiCard-root {
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.MuiCard-root:hover {
  transform: translateY(-1px);
}

/* Edge에서 Button 상태 일관성 */
.MuiButton-root:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

/* Edge에서 Chart.js 캔버스 렌더링 개선 */
canvas {
  font-family: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Edge에서 모달/다이얼로그 위치 일관성 */
.MuiDialog-paper {
  margin: 32px;
  max-height: calc(100% - 64px);
}

/* Edge에서 테이블 스타일 일관성 */
.MuiTable-root {
  border-collapse: collapse;
  width: 100%;
}

.MuiTableCell-root {
  border-bottom: 1px solid rgba(224, 224, 224, 1);
  padding: 16px;
}

[data-theme="dark"] .MuiTableCell-root {
  border-bottom: 1px solid rgba(81, 81, 81, 1);
}

/* Edge에서 Chip 컴포넌트 렌더링 개선 */
.MuiChip-root {
  font-family: inherit;
  font-size: 0.8125rem;
  line-height: 1.5;
}

/* Edge에서 Alert 컴포넌트 아이콘 정렬 */
.MuiAlert-root .MuiAlert-icon {
  margin-right: 12px;
  padding: 7px 0;
}

/* Edge에서 Navigation 드롭다운 메뉴 위치 */
.MuiMenu-paper {
  margin-top: 4px;
  max-height: calc(100vh - 96px);
  overflow-y: auto;
}

/* 접근성 개선 - 포커스 표시 통일 */
.MuiButtonBase-root:focus-visible {
  outline: 2px solid var(--theme-palette-primary-main, #4a5568);
  outline-offset: 2px;
}

/* Edge에서 로딩 스피너 애니메이션 */
.MuiCircularProgress-root {
  animation-duration: 1.4s;
}

/* 반응형 이미지 처리 */
img {
  max-width: 100%;
  height: auto;
  display: block;
}

/* Edge에서 Drawer/사이드바 스타일 */
.MuiDrawer-paper {
  box-sizing: border-box;
  border: none;
}

/* 프린트 스타일 최적화 */
@media print {
  * {
    print-color-adjust: exact;
  }
  
  .MuiButton-root,
  .MuiIconButton-root {
    display: none;
  }
}

/* 고대비 모드 지원 */
@media (prefers-contrast: high) {
  .MuiButton-outlined {
    border-width: 2px;
  }
  
  .MuiOutlinedInput-notchedOutline {
    border-width: 2px;
  }
}

/* 모션 감소 설정 지원 */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* =====================================
   반응형 여백 시스템 (Phase 2 개선)
   ===================================== */

/* 반응형 패딩은 각 컴포넌트의 sx prop으로 이동됨 */
/* 여기서는 접근성 및 터치 타겟 최적화만 유지 */

/* 모바일에서 버튼 터치 타겟 최적화 (접근성) */
@media (max-width: 600px) {
  .MuiButton-root {
    min-height: 44px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/cross-browser-compatibility.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD,+CAA+C;;AAE/C,yBAAyB;AACzB;EACE,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,uJAAuJ;EACvJ,yBAAyB;EACzB,mCAAmC;EACnC,oBAAoB;EACpB,SAAS;EACT,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;;EAEE,yBAAyB;EACzB,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;;EAEE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,uBAAuB;AACvB,mCAAmC;AACnC;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,mCAAmC;AACnC;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC,2DAA2D;AAC3D;EACE,6BAA6B;EAC7B;IACE,wBAAwB;EAC1B;;EAEA,kCAAkC;EAClC;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA,oBAAoB;EACpB;IACE,qBAAqB;EACvB;;EAEA,2BAA2B;EAC3B;IACE,aAAa;EACf;;EAEA,kCAAkC;EAClC;IACE,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;EACjC;;EAEA,iCAAiC;EACjC;;;;;IAKE,qBAAqB;EACvB;;EAEA,wBAAwB;EACxB;IACE,mBAAmB;EACrB;;EAEA,sBAAsB;EACtB;IACE,sBAAsB;EACxB;AACF;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;AACvB;;AAEA;;0CAE0C;;AAE1C,yCAAyC;;AAEzC;;0CAE0C;;AAE1C,0CAA0C;;AAE1C;;0CAE0C;;AAE1C,mEAAmE;AACnE,yBAAyB;AACzB;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA,wBAAwB;AACxB;EACE,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;;;;;;EAME,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;;EAEE,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,+CAA+C;EAC/C,aAAa;AACf;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA,cAAc;AACd;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,gBAAgB;AAChB;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA;;0CAE0C;;AAE1C,kCAAkC;AAClC,6BAA6B;;AAE7B,6BAA6B;AAC7B;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Cross-Browser Compatibility Styles for StockManager */\n/* Edge, Chrome, Firefox 브라우저 호환성을 위한 글로벌 스타일 */\n\n/* Edge/IE에서 폰트 렌더링 최적화 */\nhtml {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n  font-feature-settings: \"kern\" 1;\n}\n\nbody {\n  font-family: \"Pretendard\", \"Noto Sans KR\", \"Apple SD Gothic Neo\", \"Malgun Gothic\", \"맑은 고딕\", \"Roboto\", \"Segoe UI\", \"Helvetica Neue\", \"Arial\", sans-serif;\n  font-optical-sizing: auto;\n  font-variation-settings: \"wght\" 400;\n  /* Edge에서 기본 여백 제거 */\n  margin: 0;\n  padding: 0;\n}\n\n/* 브라우저별 박스 모델 통일 */\n*, *::before, *::after {\n  box-sizing: border-box;\n}\n\n/* Edge에서 input 요소 스타일 통일 */\ninput, textarea, select, button {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\n/* Edge에서 placeholder 스타일 통일 */\ninput::placeholder,\ntextarea::placeholder {\n  color: rgba(0, 0, 0, 0.6);\n  opacity: 1;\n}\n\n/* Edge/IE placeholder 호환성 */\ninput::-ms-input-placeholder,\ntextarea::-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.6);\n}\n\n/* 다크모드 placeholder 스타일 */\n[data-theme=\"dark\"] input::placeholder,\n[data-theme=\"dark\"] textarea::placeholder {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n[data-theme=\"dark\"] input::-ms-input-placeholder,\n[data-theme=\"dark\"] textarea::-ms-input-placeholder {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/* Edge에서 버튼 스타일 통일 */\nbutton {\n  background: none;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  font-family: inherit;\n}\n\nbutton:focus {\n  outline: 2px solid var(--theme-palette-primary-main, #4a5568);\n  outline-offset: 2px;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: none;\n}\n\n/* Edge에서 스크롤바 스타일 통일 */\n/* Webkit browsers (Chrome, Edge) */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #a1a1a1;\n}\n\n/* 다크모드 스크롤바 */\n[data-theme=\"dark\"] ::-webkit-scrollbar-track {\n  background: #2d3748;\n}\n\n[data-theme=\"dark\"] ::-webkit-scrollbar-thumb {\n  background: #4a5568;\n}\n\n[data-theme=\"dark\"] ::-webkit-scrollbar-thumb:hover {\n  background: #718096;\n}\n\n/* Firefox scrollbar */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #c1c1c1 #f1f1f1;\n}\n\n[data-theme=\"dark\"] * {\n  scrollbar-color: #4a5568 #2d3748;\n}\n\n/* Edge에서 Material-UI 컴포넌트 여백 일관성 */\n.MuiPaper-root > *:first-child {\n  margin-top: 0;\n}\n\n.MuiPaper-root > *:last-child {\n  margin-bottom: 0;\n}\n\n.MuiCard-root > .MuiCardContent-root > *:first-child {\n  margin-top: 0;\n}\n\n.MuiCard-root > .MuiCardContent-root > *:last-child {\n  margin-bottom: 0;\n}\n\n/* 브라우저별 Paper/Card 컴포넌트 패딩 보정 */\n/* Firefox와 다른 브라우저에서 MUI sx prop 패딩 값이 제대로 적용되지 않는 문제 해결 */\n@supports (-moz-appearance:none) {\n  /* 포트폴리오 페이지 통계 카드 패딩 강제 적용 */\n  .portfolio-stats-card {\n    padding: 24px !important;\n  }\n  \n  /* Grid 컨테이너 내부 Paper 컴포넌트 기본 패딩 */\n  .MuiGrid-item .MuiPaper-root:not(.MuiTableContainer-root) {\n    /* MUI의 sx={{ p: 3 }}는 24px 패딩 */\n    padding: 24px !important;\n  }\n  \n  /* 테이블 컨테이너는 패딩 제외 */\n  .MuiTableContainer-root.MuiPaper-root {\n    padding: 0 !important;\n  }\n  \n  /* 보유 종목 테이블 헤더 박스는 별도 패딩 */\n  .MuiPaper-root > .MuiBox-root:first-child {\n    padding: 16px;\n  }\n  \n  /* Card 컴포넌트는 CardContent가 패딩 처리 */\n  .MuiCard-root {\n    padding: 0 !important;\n  }\n  \n  .MuiCardContent-root {\n    padding: 24px !important;\n  }\n  \n  .MuiCardContent-root:last-child {\n    padding-bottom: 24px !important;\n  }\n  \n  /* Dialog, Drawer, Menu는 기본값 유지 */\n  .MuiDialog-paper,\n  .MuiDrawer-paper,\n  .MuiMenu-paper,\n  .MuiPopover-paper,\n  .MuiAlert-root {\n    padding: 0 !important;\n  }\n  \n  /* Typography 요소 간격 보정 */\n  .MuiPaper-root .MuiTypography-h6 {\n    margin-bottom: 16px;\n  }\n  \n  /* Box 컴포넌트 내부 요소 간격 */\n  .MuiPaper-root .MuiBox-root {\n    box-sizing: border-box;\n  }\n}\n\n/* 테이블 컨테이너 패딩 제거 */\n.MuiTableContainer-root.MuiPaper-root {\n  padding: 0 !important;\n}\n\n/* =====================================\n   계좌 관리 페이지 최적화 (Phase 5)\n   ===================================== */\n\n/* 계좌 카드 스타일은 Accounts.js sx prop으로 이동됨 */\n\n/* =====================================\n   포트폴리오 페이지 종목 카드 최적화\n   ===================================== */\n\n/* 종목 카드 스타일은 Portfolio.js sx prop으로 이동됨 */\n\n/* =====================================\n   모바일 Bottom Navigation 최적화\n   ===================================== */\n\n/* Bottom Navigation 스타일은 MobileBottomNavigation.js sx prop으로 이동됨 */\n/* 하단 메뉴를 고려한 본문 여백만 유지 */\n@media (max-width: 600px) {\n  .main-content {\n    padding-bottom: 64px;\n  }\n}\n\n/* Edge에서 그리드 레이아웃 일관성 */\n.MuiGrid-container {\n  width: 100%;\n}\n\n/* Edge에서 Typography 여백 일관성 */\n.MuiTypography-gutterBottom {\n  margin-bottom: 0.35em;\n}\n\n.MuiTypography-paragraph {\n  margin-bottom: 16px;\n}\n\n/* Edge에서 폰트 가중치 일관성 */\n.MuiTypography-h1,\n.MuiTypography-h2,\n.MuiTypography-h3,\n.MuiTypography-h4,\n.MuiTypography-h5,\n.MuiTypography-h6 {\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n/* Edge에서 한글 폰트 최적화 */\n.MuiTypography-root[lang=\"ko\"],\n.MuiTypography-root:lang(ko) {\n  word-break: keep-all;\n  overflow-wrap: break-word;\n}\n\n/* Edge에서 Card 호버 효과 일관성 */\n.MuiCard-root {\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.MuiCard-root:hover {\n  transform: translateY(-1px);\n}\n\n/* Edge에서 Button 상태 일관성 */\n.MuiButton-root:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n/* Edge에서 Chart.js 캔버스 렌더링 개선 */\ncanvas {\n  font-family: inherit;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Edge에서 모달/다이얼로그 위치 일관성 */\n.MuiDialog-paper {\n  margin: 32px;\n  max-height: calc(100% - 64px);\n}\n\n/* Edge에서 테이블 스타일 일관성 */\n.MuiTable-root {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.MuiTableCell-root {\n  border-bottom: 1px solid rgba(224, 224, 224, 1);\n  padding: 16px;\n}\n\n[data-theme=\"dark\"] .MuiTableCell-root {\n  border-bottom: 1px solid rgba(81, 81, 81, 1);\n}\n\n/* Edge에서 Chip 컴포넌트 렌더링 개선 */\n.MuiChip-root {\n  font-family: inherit;\n  font-size: 0.8125rem;\n  line-height: 1.5;\n}\n\n/* Edge에서 Alert 컴포넌트 아이콘 정렬 */\n.MuiAlert-root .MuiAlert-icon {\n  margin-right: 12px;\n  padding: 7px 0;\n}\n\n/* Edge에서 Navigation 드롭다운 메뉴 위치 */\n.MuiMenu-paper {\n  margin-top: 4px;\n  max-height: calc(100vh - 96px);\n  overflow-y: auto;\n}\n\n/* 접근성 개선 - 포커스 표시 통일 */\n.MuiButtonBase-root:focus-visible {\n  outline: 2px solid var(--theme-palette-primary-main, #4a5568);\n  outline-offset: 2px;\n}\n\n/* Edge에서 로딩 스피너 애니메이션 */\n.MuiCircularProgress-root {\n  animation-duration: 1.4s;\n}\n\n/* 반응형 이미지 처리 */\nimg {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* Edge에서 Drawer/사이드바 스타일 */\n.MuiDrawer-paper {\n  box-sizing: border-box;\n  border: none;\n}\n\n/* 프린트 스타일 최적화 */\n@media print {\n  * {\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n  \n  .MuiButton-root,\n  .MuiIconButton-root {\n    display: none;\n  }\n}\n\n/* 고대비 모드 지원 */\n@media (prefers-contrast: high) {\n  .MuiButton-outlined {\n    border-width: 2px;\n  }\n  \n  .MuiOutlinedInput-notchedOutline {\n    border-width: 2px;\n  }\n}\n\n/* 모션 감소 설정 지원 */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n/* =====================================\n   반응형 여백 시스템 (Phase 2 개선)\n   ===================================== */\n\n/* 반응형 패딩은 각 컴포넌트의 sx prop으로 이동됨 */\n/* 여기서는 접근성 및 터치 타겟 최적화만 유지 */\n\n/* 모바일에서 버튼 터치 타겟 최적화 (접근성) */\n@media (max-width: 600px) {\n  .MuiButton-root {\n    min-height: 44px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
